import { render, staticRenderFns } from "./iconRef.vue?vue&type=template&id=15a84445&scoped=true&"
import script from "./iconRef.vue?vue&type=script&lang=js&"
export * from "./iconRef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a84445",
  null
  
)

export default component.exports